import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Normaliza texto tecleado como número decimal: acepta tanto "," como "."
 * como separador (el teclado numérico del celular en español muestra
 * "," — un `<input type="number">` nativo lo rechaza silenciosamente, así
 * que el chofer no podía escribir decimales). Usar con `type="text"
 * inputMode="decimal"` en vez de `type="number"`.
 *
 * Deja solo dígitos y un único separador decimal (convertido a "."),
 * descarta cualquier otro carácter.
 */
export function normalizarEntradaDecimal(valor: string): string {
  let vioSeparador = false;
  let resultado = '';
  for (const c of valor) {
    if (c >= '0' && c <= '9') {
      resultado += c;
    } else if ((c === '.' || c === ',') && !vioSeparador) {
      resultado += '.';
      vioSeparador = true;
    }
  }
  return resultado;
}
